module.exports = __webpack_public_path__ + "img/error_404.1c5a6adc.svg";